import {CurationDashboardOperations} from "./curation-dashboard-interface";
import {IcurationWorklistItem} from "../../../interfaces/curation-worklist-item.interface";
import {CurationUtils} from "../../../utils/curation-utils";
import {Observable} from "rxjs";
import {Inject, Injectable} from '@angular/core';
import {xml2js} from 'xml-js';
import {AddCurationComponent} from "../../add-curation/add-curation.component";
import {IoptionElemet} from "../../../../shared/interfaces/IoptionElemet";
import {CurationActionCreatorService} from "../../../services/curation-action-creator.service";
import {ClinicalTrialMatchService} from "../../../services/clinical-trial-match.service";
import { AuthenticationService } from "@ispm/user/services/authentication.service";

@Injectable()
export class curationDashboardClinicalTrialService implements CurationDashboardOperations {

  constructor(private curationActionCreatorService: CurationActionCreatorService,
              private clinicalTrialMatchService: ClinicalTrialMatchService,
              private authService: AuthenticationService){}

  adaptDataToGrid(item: IcurationWorklistItem, currentConf: any, currentUserOrgId: string){
    CurationUtils.adaptCurationDataToGrid(item, currentConf, currentUserOrgId);
  }

  adaptDataToGridWithGrantedAction(item: IcurationWorklistItem, currentUserOrgId: string, actionGrantedForType: boolean) {
    CurationUtils.adaptDataToGridWithGrantedAction(item, currentUserOrgId, actionGrantedForType);
  }

  loadAddItemOptions(conf, newItemOptions: any[], curationTypeByFormName: Map<string, any>, loadFormFunc, context) {
    newItemOptions.length = 0;
  }

  getAddButtonName(){
    return 'Add new trial';
  }

  getMockList() {
    let tempList: Array<any> = [];
    for (let i = 1; i < 100; i++) {
      tempList.push({aberrationKey: i.toString(), status: 'draft', lastUpdated: i});
    }
    return Observable.of(tempList);
  }

  getCloningEnabled(): boolean{
    return false;
  }

  createCuration(){
    //let trialObject = this.clinicalTrialMatchService.getTrialFromEs(data);
    //this.curationActionCreatorService.createCurationItemV1(trialObject);
  }

  getCurationCreationData(itemData: { type: string; inputs: IoptionElemet[] }, formName: string) {
    let payload = {formName: formName}
    return {createComp : AddCurationComponent, payload : payload}
  }

  prepareCurationItem(model: any, curationType: string) {
    model.trialId = model.trialId.toUpperCase().trim();
    model.type = curationType;
    return {
      "content": model,
      "opinion": CurationUtils.buildOpinion(this.authService.user),
    }
  }

  getCurationItemByKeys(curationToCreate: any, forCurrentOrg: boolean = false) {
    return this.curationActionCreatorService.getCurationItemByKeysV1(curationToCreate,  forCurrentOrg);
  }

  createCurationItem(curationToCreate: any) {
    let req = this.clinicalTrialMatchService.getTrialFromEs(curationToCreate.content.trialId).flatMap(data => {
      let content = this.constructContentFromTrialObject(data.body);
      let trialId = curationToCreate.content.trialId;
      let type = curationToCreate.content.type;
      curationToCreate.content = content;
      curationToCreate.content.trialId = trialId;
      curationToCreate.content.type = type;
      curationToCreate.content.mentions = data.body.mentions;
      return this.curationActionCreatorService.createCurationItemV1(curationToCreate);
    }).catch(err => {
      throw err;
    });

    return req;
  }

  constructContentFromTrialObject(trialObject: any) {
    return xml2js(trialObject['xmlContent'],{compact: true });
  }

  openEditorParams(response: any) {
    return {
      curationId: response.curationItem.id,
      wfId: response.curationItem.workflowRequestId,
      revisionId: response.curationData.revisionId,
      curationType: response.curationItem.type
    }
  }

  getCurationItem(curationItemId, revisionId, type){
    return this.curationActionCreatorService.getCurationItemV1(curationItemId, revisionId, type);
  }

  updateCurationItem(curationItem, data, status) {
    data.curationData.content['hasNotes'] = true;
    return this.curationActionCreatorService.updateCurationItemV1(curationItem['curationItem']['id'], data, curationItem['curationItem']['type'], status);
  }

  updateDataFromModel(form: any, content: any, isClonedFromAnotherOrg: boolean, grantedActionsTable?:any){
    Object.keys(form).forEach(((key) => {
      content[key] = form[key];
    }));
  }

}
